import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  ContentEditable,
  forwardRef,
  Cursor,
  PortalWrapper,
} from 'mw-style-react';
import useIntl from 'useIntl';
import AppUtils from '@control-front-end/utils/utils';
import { SEARCH_SMART_CHIP_REGEXP } from '@control-front-end/common/constants/regExp';
import SmartChipPopup from '../SmartChipPopup';
import mes from './intl';
import './DescriptionEditor.scss';

const ForwardDescr = forwardRef(ContentEditable);

function DescriptionEditor(props) {
  const { accId, refEdit, description, access, onChange } = props;
  const t = useIntl();
  const [popupPos, setPopupPos] = useState(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const [query, setQuery] = useState('');

  const _focus = () => {
    if (refEdit.current) {
      refEdit.current.focus();
      Cursor.moveCursorToEnd(refEdit.current);
      refEdit.current.scrollTop = 99999;
    }
  };

  // Сохранить текущую позицию курсора
  const _saveCursorPosition = () => {
    const pos = Cursor.getCaretPosition(refEdit.current);
    if (pos !== -1) {
      setCursorPosition(pos);
    }
  };

  useEffect(() => {
    _focus();
  }, []);

  const handleOnChange = ({ value }) => {
    const el = document.querySelector('div.searchChip');
    setQuery(el ? el.innerText : '');
    const newDescription = AppUtils.htmlToBbCode(value);
    onChange(newDescription);
  };

  // Удалить поле для создания смарт чипа
  const handleRemoveChipField = () => {
    const descrHtml = refEdit.current.innerHTML;
    const newDescr = descrHtml.replace(SEARCH_SMART_CHIP_REGEXP, '@$1');
    onChange(newDescr);
    setPopupPos(null);
    setTimeout(() => _focus(), 100);
  };

  // Добавить смарт чип для объекта
  const handleAddSmartChip = ({ objType, id, title }) => {
    const type = objType === 'graphFolder' ? 'graph' : objType;
    const bbCode = ` [${type}=${id}]${title}[/${type}] `;
    const descrHtml = refEdit.current.innerHTML;
    const newDescr = descrHtml.replace(SEARCH_SMART_CHIP_REGEXP, bbCode);
    onChange(AppUtils.htmlToBbCode(newDescr));
    setPopupPos(null);
    setTimeout(() => {
      const clearText = AppUtils.makeClearText(newDescr);
      const matchLieBreak = clearText.match(/\n/g);
      const lineBreakLen = matchLieBreak ? matchLieBreak.length : 0;
      const cursorPos = cursorPosition + lineBreakLen;
      const firstPart = clearText.substring(0, cursorPos);
      const newCursorPos = `${firstPart}${title}`.length - lineBreakLen + 1;
      Cursor.moveCursorToPosition(refEdit.current, newCursorPos);
    }, 100);
  };

  // Добавить поле для создания смарт чипа
  const handleAddChipField = () => {
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);
    const { x, y } = AppUtils.getRangePosition(selection, range);
    setPopupPos({ y: y + 24, x });
    setQuery('');
    AppUtils.addChipField(selection, range);
    const descrHtml = refEdit.current.innerHTML;
    onChange(AppUtils.htmlToBbCode(descrHtml));
  };

  const handleKeyEvent = (e) => {
    if (e.key === 'Escape') {
      handleRemoveChipField();
    } else if (e.key === '@') {
      _saveCursorPosition();
      setTimeout(handleAddChipField, 0);
    }
  };

  return (
    <>
      <ForwardDescr
        id="editor"
        ref={refEdit}
        styleName="editor__field"
        type="html"
        lineNumbers={false}
        value={AppUtils.bbCodeToHtml(description, accId)}
        placeholder={t(mes.startToWriteHere)}
        onChange={handleOnChange}
        onKeyPress={handleKeyEvent}
      />
      {popupPos ? (
        <PortalWrapper
          root={document.getElementById('mainRoot')}
          position="absolute"
          width={200}
          height={200}
          offsetX={popupPos.x}
          offsetY={popupPos.y}
        >
          <SmartChipPopup
            query={query}
            users={access}
            onSelect={handleAddSmartChip}
            onClose={handleRemoveChipField}
          />
        </PortalWrapper>
      ) : null}
    </>
  );
}

DescriptionEditor.propTypes = {
  refEdit: PropTypes.object,
  accId: PropTypes.string,
  description: PropTypes.string,
  access: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

export default DescriptionEditor;
